<template>
  <Grid
    gtc="1fr 1fr"
    gta="'total-info department-info' 'table table'"
    gap="var(--r-space-md) var(--r-space-sp)"
    class="full-height"
  >
    <DepartmentInfo class="sticky-card" />
    <TotalInfo class="sticky-card" />
    <ScenariosTable />
  </Grid>
</template>

<script>
import ScenariosModule from './scenarios-module'
// Components
import DepartmentInfo from './components/DepartmentInfo'
import TotalInfo from './components/TotalInfo'
import ScenariosTable from './components/scenarios-table/ScenariosTable'

export default {
  components: {
    DepartmentInfo,
    TotalInfo,
    ScenariosTable
  },

  beforeCreate() {
    this.$store.registerModule('scenarios', ScenariosModule)
  },

  beforeDestroy() {
    this.$store.unregisterModule('scenarios')
  }
}
</script>

<style lang="scss" scoped>
.sticky-card {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
